import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SectionLabel, FadeUp } from "@/components/Reveal";
import VesselPattern from "@/components/VesselPattern";
import { useLang } from "@/i18n/LanguageContext";

const FAQ = () => {
  const { t } = useLang();
  const pre = t.faq.pre.split("\n");
  return (
  <section id="faq" data-testid="faq-section" className="relative overflow-hidden bg-ivory text-midnight">
    <VesselPattern
      className="pointer-events-none absolute right-0 top-0 h-1/2 w-1/3"
      stroke="#0D0D0D"
      opacity={0.045}
    />
    <div className="mx-auto max-w-[1680px] px-6 py-20 lg:px-12 lg:py-32">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <SectionLabel index="05" text={t.faq.label} light />
          <FadeUp delay={0.1}>
            <h2 className="mt-8 font-serif text-4xl font-light leading-[1.1] md:text-5xl lg:text-6xl">
              {pre[0]}
              {pre.length > 1 && <br />}
              <span className="italic text-[#8a6f45]">{t.faq.em}</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.2}>
            <p className="mt-8 max-w-sm font-sans text-sm font-light leading-relaxed text-midnight/60">
              {t.faq.sub}
            </p>
          </FadeUp>
        </div>

        <FadeUp delay={0.15} className="lg:col-span-7">
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {t.faq.items.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-b border-gold/30"
              >
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="py-6 text-left font-serif text-xl font-light text-midnight transition-colors duration-300 hover:text-[#8a6f45] hover:no-underline md:text-2xl [&_svg]:stroke-[1.25] [&_svg]:text-gold"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-answer-${i}`}
                  className="pb-6 font-sans text-sm font-light leading-relaxed text-midnight/65"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </div>
  </section>
  );
};

export default FAQ;
